export default __webpack_public_path__ + "static/media/Nilson Domingues_.e51ab87e.png";